import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { Venimpcli } from "../veninterfaces/Venimpcli";
import { VenMaeCliente } from '../veninterfaces/venmaecliente';
import { VenmaeclienteService } from '../venservicios/venmaecliente.service';
//
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { DatePipe } from '@angular/common';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import * as XLSX from 'xlsx';//CDPJ
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { isNullOrUndefined } from 'util';
import { UploadfilesService } from '../../advantage/advantageservices/uploadfiles.service';
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';
import { VenimpclientesService } from "../venservicios/venimpclientes.service"

@Component({
  selector: 'app-venimpclientes',
  templateUrl: './venimpclientes.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class VenimpclientesComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  @ViewChild('inputFile') inputfile: ElementRef;
  private readonly extensionesExcelPermitidas = [
    'xlsx',
    'xls'
  ];
  lblvalida: string = '';
  maecliente: VenMaeCliente = {};
  CNECC;
  Nodupruc: number;//CDPJ
  bolcliente: boolean;
  haycambiosSinGuardar = false;

  barraBotones2: boolean;
  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  botonPrimero: boolean;
  botonAnterior: boolean;
  botonSiguiente: boolean;
  botonUltimo: boolean;

  indicador: any;
  permisoImpcli: SegMaePermiso;

  public frameworkComponents;
  rowSelection = 'multiple';

  rowStyle;
  largo: string;
  // detdepcliSelected: Cxcdetdepcli;
  index = 0;

  displayDialogBus: boolean;
  displayDialogBusquedaFast: boolean;
  types: SelectItem[];
  busquedacampos: any[];
  tabla: string;
  consulta: string;
  arregloCons: any[];
  arregloBus: any[];
  where: string;
  opcion: string;
  spin: boolean;
  datosJson;
  // autorizacion
  claveAuth: string;
  autorizacionCodigo: string;
  bolAutorizacion: boolean;
  displayDialogAutorizacion: boolean;

  //
  modoimportacion = false;
  archivoProcesado = false;
  archivoSeleccionado: File = null;
  archivoNombre = '';

  //
  nombrePlantilla = 'PLANTILLA_CLIENTES.xlsx';
  defaultImpcliente: any;
  impcienteselected: Venimpcli = null;






  columnDefsImpCli = [
    {
      headerName: 'No', field: 'NUMERO', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 68, cellStyle: { textAlign: 'right' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'CODCLIENTE', field: 'CLI_CODIGO', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 140, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'TIPOIDE', field: 'CLI_TIPOIDE', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 89, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'RUCIDE', field: 'CLI_RUCIDE', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },

    {
      headerName: 'NOMBRE', field: 'CLI_NOMBRE', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'NOMBREC', field: 'CLI_NOMBREC', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 95, cellStyle: { textAlign: 'right' },
      onCellDoubleClicked: (params) => { }
    },

    {
      headerName: 'VENDEDOR', field: 'VEN_CODIGO', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },

    {
      headerName: 'GRUPO', field: 'GRU_CODIGO', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },

    {
      headerName: 'DIRECCION', field: 'CLI_DIRECCION1', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'TELEFONO.', field: 'CLI_TELEFONO1', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'EMAIL', field: 'CLI_CORREO', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'CCON1', field: 'CON_CODIGO1', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'CCON2', field: 'CON_CODIGO2', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'LISTA', field: 'CLI_LISTA', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'FECHA NACIMIENTO', field: 'CLI_FECHANACIMIENTO', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'SEXO', field: 'CLI_SEXO', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'ESTADO CIVIL', field: 'CLI_ESTCIV', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'PROVINCIA', field: 'CLI_PROVINCIA', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'CANTON', field: 'CAN_CODIGO', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'PARROQUIA', field: 'PARR_CODIGO', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    },
    {
      headerName: 'OBSERVACION', field: 'OBSERVACION', editable: (params) => { return false; }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => { }
    }

    /*p_CLI_PROVINCIA ven_maecliente.CLI_PROVINCIA%TYPE,
    p_CAN_CODIGO ven_maecliente.CAN_CODIGO%TYPE,
    p_PARR_CODIGO ven_maecliente.PARR_CODIGO%TYPE*/

  ];
  constructor(public init: NuevoComponentService, public venimpclientesService: VenimpclientesService,
    private busquedaSer: InvbusquedaService, private datePipe: DatePipe, private permisosService: PermisosService,
    private messageService: MessageService, private confirmationService: ConfirmationService, private auditoriagral: AuditoriagralService,
    public uploadFileService: UploadfilesService, private utilitariosService: UtilitariosService, public cliService: VenmaeclienteService) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.rowStyle = (params) => {
      if (params.data.EXISTE === 'SI') {
        return { background: 'rgb(245,236,166)' };
      }
    };

    this.defaultImpcliente = {
      editable: true,
      objeto: 'impcliente',
      resizable: true
    };
  }

  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.barraBotones2 = true;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;

    // this.cxcdepositocliService.encdepcli[this.indicador] = {};
    // this.cxcdepositocliService.detdepcli = [];
    // this.detdepcliSelected = {};
    // this.lblbannombre = '';
    this.largo = '-5800';
    this.venimpclientesService.regtotal = Number(0).toFixed(0)
    await this.getPermisos()

  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoImpcli = data[0];
        } else {
          this.permisoImpcli = null;
        }
      } else {
        this.permisoImpcli = null;
      }
    } catch (e) {
      this.permisoImpcli = null;
      this.messageService.add({
        key: 'venimpcli',
        severity: 'error',
        summary: 'Información',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  manejarSenales(valor) {
    if (valor === 'Nuevo') {
      this.nuevo()
      return;

    }
    if (valor === 'Guardar') {
      //console.log('Si se inserta')
      if (this.permisoImpcli.PERTODO === 1) {
        this.validarGuardar()
      } else {
        if (this.permisoImpcli.PERINSERCION === 1) {
          this.validarGuardar();
        } else {
          this.messageService.add({
            key: 'venimpcli',
            severity: 'eror',
            summary: 'Información',
            detail: 'Acción denegada '
          })
        }
      }
      return;

    }
    if (valor === 'Visto') {
      this.validarProcesamiento;
      return;
    }
    if (valor === 'Cancelar') {
      this.cancelar();
      return;
    }
    if (valor === 'Borrar') {
      this.eliminarSeleccionados();
      return;
    }
    if (valor === 'Descargar') {
      this.descargarDemo();
      return;
    }
    if (valor === 'Demo') {
      this.descargarDemo();
      return;
    }
    if (valor == 'Excel') {
      this.abrirSelectorExcel();
      return;

    }
    if (valor === 'Salir') {
      this.salir();
      return
    }

  }




  nuevo() {

    this.venimpclientesService.impclientes = [];
    this.datosJson = [];
    this.archivoNombre = '';

    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.spin = false;
    this.limpiarInputFile();

  }
  seleccionItem(params: any): void {

    try {
      // console.log('evento recibido', params);

      if (params === 'subirxls') {
        this.abrirSelectorExcel();
        return;
      }

      if (params && typeof params === 'object') {
        const opcion = params.opcion ||
          params.accion ||
          params.tipo ||
          params.nombre ||
          params.valor;
        if (opcion === 'subirxls' || opcion === 'Excel' || opcion === 'subirExcel' || opcion === 'XLS') {
          this.abrirSelectorExcel();
          return;
        }
        //  console.error('No se encontró ')

      }

      if (params && params.nameObject === this.defaultImpcliente.objeto && params.object) {
        this.impcienteselected = params.object;
        this.indicador = params.indicador !== undefined ? params.indicador : params.rowIndex;
        // console.log ('cliente seleccionado ', this.impcienteselected);
        return;
      }
      let opcion = params.opcion
      if (opcion === 'eliminar' || this.opcion === 'Eliminar') {
        this.confirmeliminaregistro();
        return

      }
      //  console.error('No se reconoció el evento de la grilla ', params)
    } catch (error) {
      console.log('error al insertar ')
    }

  }
  confirmeliminaregistro() {
    if (!this.impcienteselected) {
      this.messageService.add({
        key: 'venimpcli',
        severity: 'warn',
        summary: 'Información',
        detail: 'Seleccione una linea para eliminar'
      })
      return;
    }
    this.confirmationService.confirm({
      message: '¿Esta seguro de eliminar al registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmvenimpcli',
      acceptLabel: 'SI',
      rejectLabel: 'NO',
      accept: async () => {
        this.confirmationService.close();
        try {
          const lista = this.venimpclientesService.impclientes;
          const indice = lista.indexOf(this.impcienteselected);
          if (indice === -1) {
            this.messageService.add({
              key: 'venimpcli',
              severity: 'error',
              summary: 'Información',
              detail: 'No se encontró el registro seleccionado'
            });
            return;
          }
          this.venimpclientesService.impclientes =
            lista.filter(
              (cliente, posicion) =>
                posicion !== indice
            )
          this.venimpclientesService.impclientes.forEach(
            (cliente, posicion) => {
              cliente.NUMERO = posicion + 1;
            }
          )
          this.aggrid.refreshaggrid(this.venimpclientesService.impclientes, this.defaultImpcliente.objeto);
          this.impcienteselected = null;
          this.indicador = -1;
          this.haycambiosSinGuardar = true;
          if (this.venimpclientesService.impclientes.length === 0) {
            this.botonGuardar = true;
            this.botonRegresar = true;
            this.botonBorrar = true;
            this.haycambiosSinGuardar = false;
          }
          this.messageService.add({
            key: 'venimpcli',
            severity: 'success',
            summary: 'Información',
            detail: 'Registro eliminado correctamente'
          });
        } catch (error) {
          console.error('Error eliminando la línea ', error);
          this.messageService.add({
            key: 'venimpcli',
            severity: 'error',
            summary: 'Información',
            detail: 'No se pudo eliminar el registro'
          });

        }
      }
    })

  }
  abrirSelectorExcel(): void {
    if (this.inputfile && this.inputfile.nativeElement) {
      this.inputfile.nativeElement.value = '';

      this.inputfile.nativeElement.click();
      return;
    } else {
      console.error(
        'No se encontr+o el input del archivo Excel '
      );
    }
  }

  ///lectura de exel
  onBasicUpload(event: any): void {
    console.log('Evento del archivo ', event);
    const input = event.target as HTMLInputElement;


    if (!input.files || input.files.length === 0) {
      console.error('No se recibio ningun archivo ');
      return;
    }

    const archivo: File = input.files[0];
    console.log('Archivo seleccionado:', archivo);

    const nombreArchivo = String(archivo.name).trim().toLowerCase()

    const esArchivoExcel = nombreArchivo.endsWith('.xlsx') ||
      nombreArchivo.endsWith('.xls');
    console.log('Nombre normalizado', nombreArchivo);
    console.log('Es archivo Excel ? ', esArchivoExcel);

    if (!esArchivoExcel) {
      this.messageService.add({
        key: 'venimpcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Solo se permite archivos Excel .xlsx o .xls '
      });
      this.limpiarInputFile();
      return;

    }
    console.log('ARCHIVO EXCEL ACEPTADO');
    this.spin = true;
    this.archivoNombre = archivo.name;
    const reader = new FileReader();
    reader.onload = async (resultado: ProgressEvent<FileReader>) => {
      try {
        console.log('El archivo termino de leerse ');
        if (!resultado.target || !resultado.target.result) {
          throw new Error('no se puedo obtener el contenido del archivo ');
        }
        const contenido = resultado.target.result;
        const workbook = XLSX.read(
          contenido, {
          type: 'array',
          cellDates: true
        }
        );
        if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
          throw new Error(
            'El archivo no contiene hojas '
          )
        }
        ///Se utiliza la primera hoja del libro 
        //despues se guarda con el mismo nombre hoja1
        const nombrePrimeraHoja = workbook.SheetNames[0];
        console.log('Hoja Seleccionada ', nombrePrimeraHoja)

        const hoja = workbook.Sheets[nombrePrimeraHoja];
        if (!hoja) {
          throw new Error('No se pudo leer la primera hoja del archivo')

        }
        this.datosJson = XLSX.utils.sheet_to_json(
          hoja, {
          defval: '',
          raw: false
        }
        );
        this.datosJson = this.datosJson.map((item: any) => {
          Object.keys(item).forEach(
            (campo: string) => {
              if (campo.indexOf('__EMPTY') === 0
              ) {
                delete item[campo];
              }
            }
          )
          return item;
        })
        console.log('Datos encontrados en excel', this, this.datosJson);
        this.datosJson = this.datosJson.filter(
          (item: any) => {
            return Object.keys(item).some(
              (campo: string) => {
                return String(
                  item[campo] === null ||
                    item[campo] === undefined
                    ? ''
                    : item[campo]
                ).trim() !== '';
              }
            )
          }
        )
        console.log('Datos encontrados en excel ', this.datosJson)

        if (!this.datosJson || this.datosJson.lenght === 0) {
          this.spin = false;

          this.messageService.add({
            key: 'venimpcli',
            severity: 'error',
            summary: 'Error;',
            detail: 'El Archivo Excel no contiene información'
          });
          this.limpiarInputFile();
          return;
        }
        console.log('Cantidad de registros  ', this.datosJson.lenght)

        await this.validarexcel();
        this.limpiarInputFile();

      } catch (error) {
        console.error('Error procesando excel', error);
        this.spin = false;
        const mensajeerror = error && (error as any).message
          ? (error as any).message
          : String(error);

        this.messageService.add({
          key: 'venimpcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Hubo un error al leer los datos del archvivo ' + mensajeerror
        });
        this.limpiarInputFile();
      }
    }
    reader.onerror = error => {
      console.error('Error de FileReader'), error
      this.spin = false;

      this.messageService.add({
        key: 'venimpcli',
        severity: 'error',
        summary: 'Error;',
        detail: 'No se pudo leer el archivo seleccionado '
      });
      this.limpiarInputFile();
    };

    reader.readAsArrayBuffer(archivo);
  }


  esRegistroCompletamenteVacio(registro) {
    let vacio = true;
    for (const key in registro) {
      if (registro[key] !== null && registro[key] !== undefined && String(registro[key]).trim() !== '') {
        vacio = false;
        break;
      }
    }
    return vacio;
  }

  //validacion Excel 
  async validarexcel() {
    try {
      this.spin = true
      const clientes: Venimpcli[] = []
      const codigos = [];
      const identificaciones = [];
      let numeroFila = 1;

      let numfila = 1;
      const clientesvalida = this.datosJson.map(({
        CLI_CODIGO, CLI_RUCIDE

      }) => ({
        clicodigo: CLI_CODIGO,
        cliruc: CLI_RUCIDE
      }))
      // const vendedor = Array.from(new Set(this.datosJson.map(item => String(item.VEN_CODIGO)).filter(x => x !== null && String(x).trim() !== '')));
      // const concod1 = Array.from(new Set(this.datosJson.map(item => String(item.CON_CODIGO1 || '')).filter(x => x !== null && String(x).trim() !== '')));
      // const concod2 = Array.from(new Set(this.datosJson.map(item => String(item.CON_CODIGO2 || '')).filter(x => x !== null && String(x).trim() !== '')));
      // const clicod = Array.from(new Set(this.datosJson.map(item => String(item.CLI_CODIGO || '')).filter(x => x !== null && String(x).trim() !== '')));
      //console.log(clientesvalida)
      const arreglo = this.datosJson.map(({
        CLI_CODIGO, CLI_RUCIDE, GRU_CODIGO, VEN_CODIGO,
        CON_CODIGO1, CON_CODIGO2,
      }) => ({
        p_CLI_CODIGO: CLI_CODIGO,
        p_CLI_RUCIDE: CLI_RUCIDE,
        p_GRU_CODIGO: GRU_CODIGO,
        p_VEN_CODIGO: VEN_CODIGO,
        p_CON_CODIGO1: CON_CODIGO1,
        p_CON_CODIGO2: CON_CODIGO2,
        p_USUIDENTIFICACION: this.venimpclientesService.usuario.identificacion
      }))
      await this.venimpclientesService.eliminarclitmp()
      await this.venimpclientesService.insertarclitmp(arreglo)
      const data = await this.venimpclientesService.getclivalidacion();
      const data2 = await this.venimpclientesService.getvenvalidacion();
      const data3 = await this.venimpclientesService.getconcod1validacion()
      const data4 = await this.venimpclientesService.getconcod2validacion()
      const data5 = await this.venimpclientesService.getclirucvalidacion();
      const data6 = await this.venimpclientesService.getgrupcodvalidacion();
      //console.log(data)
      if (data !== null && Object.keys(data).length > 0) {
        const existentes = new Set(
          data.map(x => `${x.CLI_CODIGO}`)
        )
        this.datosJson.forEach(cliente => {
          const clave = `${cliente.CLI_CODIGO}`
          cliente.VALEXISTE = existentes.has(clave)
        })
      }
      if (data5 !== null && Object.keys(data5).length > 0) {
        const existentes = new Set(
          data5.map(x => `${x.CLI_RUCIDE}`)
        )
        this.datosJson.forEach(cliente => {
          const clave = `${cliente.CLI_RUCIDE}`
          cliente.VALEXISTE = existentes.has(clave)
        })
      }
      if (data2 !== null && data2 !== undefined) {
        if (data2.length > 0) {
          const cadena = data2.map(item => String(item.VEN_CODIGO)).join(',')
          this.messageService.add({
            key: 'venimpcli',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes vendedores, por favor revisar: ' + cadena
          });
          this.spin = false
          return;
        }
      }
      if (data3 !== null && Object.keys(data3).length > 0) {
        if (data3.length > 0) {
          const cadena = data3.map(item => String(item.CON_CODIGO1)).join(',')
          this.messageService.add({
            key: 'venimpcli',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes cuentas contables del campo CON_CODIGO1, por favor revisar: ' + cadena
          });
          this.spin = false
          return;
        }
      }
      if (data4 !== null && Object.keys(data4).length > 0) {
        if (data4.length > 0) {
          const cadena = data4.map(item => String(item.CON_CODIGO2)).join(',')
          this.messageService.add({
            key: 'venimpcli',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes cuentas contables del campo CON_CODIGO2, por favor revisar: ' + cadena
          });
          this.spin = false
          return;
        }
      }
      if (data6 !== null && Object.keys(data6).length > 0) {
        if (data6.length > 0) {
          const cadena = data6.map(item => String(item.GRU_CODIGO)).join(',')
          this.messageService.add({
            key: 'venimpcli',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes grupos, por favor revisar: ' + cadena
          });
          this.spin = false
          return;
        }
      }
      //console.log(this.datosJson)
      for (const item of this.datosJson) {
        if (item.CLI_FECHANACIMIENTO.toString().includes('-')) {
          item.CLI_FECHANACIMIENTO = this.datePipe.transform(item.CLI_FECHANACIMIENTO, 'dd/MM/yyyy')
        }
        const cliente: Venimpcli = {
          NUMERO: numeroFila,
          CLI_CODIGO: this.convertirTexto(item.CLI_CODIGO),
          CLI_TIPOIDE: this.convertirTexto(item.CLI_TIPOIDE),
          CLI_RUCIDE: this.convertirTexto(item.CLI_RUCIDE),
          CLI_NOMBRE: this.convertirTexto(item.CLI_NOMBRE),
          CLI_NOMBREC: this.convertirTexto(item.CLI_NOMBREC),
          VEN_CODIGO: this.convertirTexto(item.VEN_CODIGO),
          GRU_CODIGO: this.convertirTexto(item.GRU_CODIGO),
          CLI_DIRECCION1: this.convertirTexto(item.CLI_DIRECCION1),
          CLI_TELEFONO1: this.convertirTexto(item.CLI_TELEFONO1),
          CLI_CORREO: this.convertirTexto(item.CLI_CORREO),
          CON_CODIGO1: this.convertirTexto(item.CON_CODIGO1),
          CON_CODIGO2: this.convertirTexto(item.CON_CODIGO2),
          CLI_LISTA: this.convertirTexto(item.CLI_LISTA),
          CLI_FECHANACIMIENTO: this.convertirTexto(item.CLI_FECHANACIMIENTO) || '',
          CLI_SEXO: this.convertirTexto(item.CLI_SEXO) || '',
          CLI_ESTCIV: this.convertirTexto(item.CLI_ESTCIV) || '',
          CLI_PROVINCIA: this.convertirTexto(item.CLI_PROVINCIA) || '',
          CAN_CODIGO: this.convertirTexto(item.CAN_CODIGO) || '',
          PARR_CODIGO: this.convertirTexto(item.PARR_CODIGO) || '',
          EXISTE: isNullOrUndefined(item.VALEXISTE) ? 'NO' : item.VALEXISTE ? 'SI' : 'NO',
          ESTADO: 'VALIDO',
          OBSERVACION: '',
          CLI_VALIDACION: ''
        };
        const errores = [];
        if (cliente.EXISTE === 'SI') {
          errores.push('El cliente ya existe');
        }
        if (cliente.CLI_CODIGO === '') {
          errores.push('El campo codigo no puede estar vacio ');
        }
        if (cliente.CLI_TIPOIDE === '') {
          errores.push('El campo TIPOIDE no puede estar vacio ');
        }
        if (cliente.CLI_RUCIDE === '') {
          errores.push('El campo RUCIDE no puede estar vacio ');
        }
        if (cliente.CLI_NOMBRE === '') {
          errores.push('El campo NOMBRE no puede estar vacio ');
        }
        if (cliente.CLI_NOMBREC === '') {
          errores.push('El campo NOMBRE CORTO no puede estar vacio ');
        }
        if (cliente.VEN_CODIGO === '') {
          errores.push('El campo COD. VENDEDOR no puede estar vacio ');
        }
        if (cliente.GRU_CODIGO === '') {
          errores.push('El campo COD.GRUP no puede estar vacio ');
        }
        if (cliente.CLI_DIRECCION1 === '') {
          errores.push('El campo DIRECCION no puede estar vacio ');
        }
        if (cliente.CLI_TELEFONO1 === '') {
          errores.push('El campo TELEFONO no puede estar vacio ');
        }
        if (cliente.CLI_CORREO === '') {
          errores.push('El campo EMAIL no puede estar vacio ');
        }
        if (cliente.CON_CODIGO1 === '') {
          errores.push('El campo COD.CON1 no puede estar vacio ');
        }
        if (cliente.CON_CODIGO2 === '') {
          errores.push('El campo COD.CON1 no puede estar vacio ');
        }
        if(cliente.CON_CODIGO1.substr(-1, 1) === '.'){
          errores.push('No se puede elegir esa cuenta contable en Referencia Contable');
        }
        if(cliente.CON_CODIGO2.substr(-1, 1) === '.'){
          errores.push('No se puede elegir esa cuenta contable en Referencia Contable');
        }
        //if (cliente.CLI_RUCIDE !== '' && /[0-9]+$/.test(cliente.CLI_RUCIDE)) {
          const tipo = String(cliente.CLI_TIPOIDE).trim();
          const vria = await this.validaConsultaRespuesta(cliente.CLI_RUCIDE, tipo);

          // if (tipo === '1' && Number(this.ValidaRuc(cliente.CLI_RUCIDE)) !== 1) {
          //   errores.push('El ruc ingresado no es valido ')
          // };
          // if (tipo === '2' && Number(this.ValidaCedula(cliente.CLI_RUCIDE)) !== 1) {
          //   errores.push('La cédula ingresada no es valida')
          // };
          if (vria === 1) {
            cliente.CLI_VALIDACION = 'Bien'
          } else if (vria === 3) {
            cliente.CLI_VALIDACION = 'Autoriza'
          } else if (vria === 4) {
            cliente.CLI_VALIDACION = 'Bien'
          } else {
            errores.push('El IDE ingresado no es valido ')
          }
          //tipo -6 
          if (tipo === '6' && cliente.CLI_RUCIDE !== '9999999999999') {
            errores.push('La identificación es consumidor final debe ser 9999999999999')
          }
        //}
        //validar códio repetido 
        if (codigos.indexOf(cliente.CLI_CODIGO) >= 0) {
          errores.push('El código del cliente está repetido en el excel ');
        }
        if (identificaciones.indexOf(cliente.CLI_RUCIDE) >= 0) {
          errores.push('el RUC O Cédula esta repetido en el excel ')
        };
        //registra el valor para validar las siguientes filas 

        if (cliente.CLI_CODIGO !== '') {
          codigos.push(cliente.CLI_CODIGO)
        };
        if (cliente.CLI_RUCIDE !== '') {
          identificaciones.push(cliente.CLI_RUCIDE);
        }
        if (errores.length > 0) {
          cliente.ESTADO = 'ERROR';
          cliente.OBSERVACION = errores.join(' , ');
        }
        this.venimpclientesService.impclientes.push(cliente);
        numeroFila++;
      }

      //this.venimpclientesService.impclientes = clientes

      this.aggrid.refreshaggrid(this.venimpclientesService.impclientes, this.defaultImpcliente.objeto)
      console.log('Regristro insertados en la grilla ', this.venimpclientesService.impclientes);
      //Contar resgistros con erroes 

      const errores = clientes.filter(item => item.ESTADO === 'ERROR');
      if (errores.length > 0) {
        this.botonGuardar = true;
        this.messageService.add({
          key: 'venimpcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Existe' + errores.length + 'registros con errores. Revise la columna Observacion'
        });
      } else {
        this.botonGuardar = false;
        this.messageService.add({
          key: 'venimpcli',
          severity: 'success',
          summary: 'Exito',
          detail: 'El archivo fue validado correctamente '
        });;

      }
      this.haycambiosSinGuardar = true;
      this.botonBorrar = false;
      this.spin = false;

    } catch (error) {
      this.spin = false;
      this.messageService.add({
        key: 'venimpcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrido un error al validar el excel ' + error
      });
      console.log(error)
    }
  }

  convertirTexto(valor) {
    if (valor === null || valor === undefined) {
      return '';
    }
    return String(valor).trim();
  }
  ///PROCESAR CLIENTES 
  validarProcesamiento() {
    if (!this.venimpclientesService.impclientes || this.venimpclientesService.impclientes.length === 0) {
      this.messageService.add({
        key: 'venimpcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Debe seleccionar un archivo excel'
      });
      return;
    }
    const errores = this.venimpclientesService.impclientes.filter(item => item.ESTADO === 'ERROR');
    if (errores.length > 0) {
      this.messageService.add({
        key: 'venimpcli',
        severity: 'error',
        summary: 'Error',
        detail: 'No se puede procesar porque existen registros con errores'
      });
      return;
    }
    this.confirmationService.confirm({
      message: '¿Está seguro de preocesar los clientes?',
      header: 'Confirmar Acción',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmvenimpcli',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        await this.procesarclientes();
      }
    });
  }
  async procesarclientes() {
    try {
      this.spin = true;
      for (const iterator of this.venimpclientesService.impclientes) {
        if (iterator.EXISTE === 'NO') {
          const data = await this.venimpclientesService.procesarclientes(iterator);
          iterator.EXISTE = 'SI';
          iterator.ESTADO = 'PROCESADO';
          iterator.OBSERVACION = 'CLIENTE PROCESADO CORRECTAMENTE';
        }
      }
      this.messageService.add({
        key: 'venimpcli',
        severity: 'success',
        summary: 'Exito',
        detail: 'Los clientes se crearon de forma exitosa '
      });
      this.botonGuardar = true;
      this.spin = false;

    } catch (error) {
      this.spin = false;
      this.messageService.add({
        key: 'venimpcli',
        severity: 'success',
        summary: 'Exito',
        detail: 'Hubo un error al crear los clientes ' + error
      });
      return;
    }
  }



  async descargarDemo() {
    try {
      const rs: any = await this.uploadFileService.getDocument('PLANTILLA_CLIENTES.xlsx');
      this.downloadDocument(rs.respuesta, 'PLANTILLA_CLIENTES.xlsx');
    } catch (err) {
      this.messageService.add({
        key: 'venimpcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrio un error al encontrar el archivo'
      });
    }
  }
  downloadDocument(strBase64, filename) {
    const byteCharacters = atob(strBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const data = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = data;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 1000)
  }

  //borrar filas 
  eliminarSeleccionados() {
    if (!this.venimpclientesService.impclientes || this.venimpclientesService.impclientes.length === 0) {
      this.messageService.add({
        key: 'venimpcli',
        severity: 'error',
        summary: 'Información',
        detail: 'No existe registro por eliminar'
      });
      return;
    }
    this.confirmationService.confirm({
      message: '¿Está seguro de limpiar la importación?',
      header: 'Confirmar Accióm',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmvenimpcli',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.nuevo();
      }
    });
  }
  cambio(event) {
    /*recive el nuevo arreglo cuando agggrid elimina o modifica una fila  */
    if (event && Array.isArray(event)) {
      this.venimpclientesService.impclientes = event;
    }
  }

  /// cancelar y salir 
  cancelar() {

    if (!this.haycambiosSinGuardar) {
      this.recargarformulario();
      return;
    }
    this.confirmationService.confirm({
      message: '¿Está seguro de cancelar la importacion? ',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangule',
      key: 'confirmvenimpcli',
      accept: () => {
        this.recargarformulario();
      },
    })
  }

  recargarformulario() {
    this.venimpclientesService.impclientes = [];
    this.archivoNombre = '';
    //if (this.inputfile) {
    this.inputfile.nativeElement.value = '';

    if (this.aggrid) {
      this.aggrid.refreshaggrid([], this.defaultImpcliente.objeto);

    }
    this.spin = false;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = true;
    this.botonRegresar = false;

    this.haycambiosSinGuardar = false;

    //}
  }
  limpiardatos() {

  }
  limpiarInputFile() {
    if (this.inputfile && this.inputfile.nativeElement) {
      this.inputfile.nativeElement.value = '';
    }
  }
  encontrarregistro() { }
  salir() {
    this.venimpclientesService.impclientes = [];
    this.datosJson = [];
    this.init.tabs.splice(this.init.tabindex, 1);
  }
  changeTabs(event) {
    this.index = event.index;
  }
  ///////////////////////////////////


  async validaColocarLabels(tipo) {
    if (tipo === 1) {
      this.lblvalida = "Bien";
    }
    if (tipo === 2) {
      this.lblvalida = "Mal";
    }

    if (tipo === 3) {
      this.lblvalida = "Autoriza";
    }

    // PARA PASAPORTES
    if (tipo === 4) {
      this.lblvalida = "Bien";
    }

    if (tipo === 6) {
      this.lblvalida = "SRI";
    }

    let codcliente = '';
    console.log('this.bolcliente', this.bolcliente)
    if (this.bolcliente === false) {
      codcliente = this.maecliente.CLI_RUCIDE;
    } else {
      codcliente = this.maecliente.CLI_CODIGO;
    }
    if (this.bolcliente === false) {
      this.maecliente.CLI_CODIGO = this.maecliente.CLI_RUCIDE;
    }
    if (this.bolcliente === false && this.CNECC === 1) {
      this.maecliente.CLI_CODIGO = '';
    }

    // const formsricom = await this.cliService.erExisteCliente(this.maecliente.CLI_RUCIDE, codcliente).toPromise();
    // if (formsricom[0] !== undefined) {
    //   if (Number(formsricom[0].COUNT) > 0) {
    //     this.messageService.add({
    //       key: 'cliente',
    //       severity: 'warn',
    //       summary: 'Información',
    //       detail: 'Cliente ya existe'
    //     });
    //     this.lblvalida = "Mal";
    //   } else {
    //     if (this.bolcliente === false) {
    //       this.maecliente.CLI_CODIGO = this.maecliente.CLI_RUCIDE;
    //     }
    //   }
    // }
    //  CDPJ
    if (this.Nodupruc === 1) {
      const formsricom = await this.cliService.erExisteCliente(this.maecliente.CLI_RUCIDE, codcliente).toPromise();
      if (formsricom[0] !== undefined) {
        if (Number(formsricom[0].COUNT) > 0) {
          this.messageService.add({
            key: 'cliente',
            severity: 'warn',
            summary: 'Información',
            detail: 'Cliente ya existe'
          });
          this.lblvalida = "Mal";
          this.maecliente.CLI_CODIGO = ''
          this.spin = false;
        } else {
          if (this.bolcliente === false) {
            this.maecliente.CLI_CODIGO = this.maecliente.CLI_RUCIDE;
          }
          if (this.bolcliente === false && this.CNECC === 1) {
            this.maecliente.CLI_CODIGO = '';
          }
        }
      }
    }//else{
    //   const formsricom = await this.cliService.erExisteClienteCod(codcliente).toPromise();
    //   if (formsricom[0] !== undefined) {
    //     if (Number(formsricom[0].COUNT) > 0) {
    //       this.messageService.add({
    //         key: 'cliente',
    //         severity: 'warn',
    //         summary: 'Información',
    //         detail: 'Cliente ya existe'
    //       });
    //       this.lblvalida = "Mal";
    //     } else {
    //       if (this.bolcliente === false) {
    //         this.maecliente.CLI_CODIGO = this.maecliente.CLI_RUCIDE;
    //       }
    //     }
    //   }
    // }
    this.spin = false;
    //CDPJ

  }

  verificaId(identificacion, tipo): boolean {
    const numero = identificacion;
    let bollong = false;
    let bolTipo = false;
    if (numero.trim().length === 10 || numero.trim().length === 13) {
      bollong = true;
    }

    if (!bollong) {
      // CompositeUtilities.openError(,"Error","La longitud del
      // identificador deve ser de 10 o de 13 para poder verificarlo.);
      console.log('La longitud del identificador  deve ser de 10 o de 13 para poder verificarlo.');
      // errorValidacionId = "La longitud del identificador  deve ser de 10 o de 13 para poder verificarlo.";
      return false;
    }

    switch (tipo) {
      case 1:
        if (numero.trim().length === 10) {
          bolTipo = true;
        }
        break;

      case 2:
        if (numero.trim().length === 13) {
          bolTipo = true;
        }
        break;
      default:
        break;
    }

    if (!bolTipo) {
      // CompositeUtilities.openError(,"Error","La longitud del
      // identificador deve ser de 10 o de 13 para poder verificarlo.);
      console.log('El numero ingresado no corresponde a  tipo de identificación  elegido.');
      // errorValidacionId = "El numero ingresado no corresponde a  tipo de identificación  elegido.";
      return false;
    }

    let suma = 0;
    let residuo = 0;
    let pri = false;
    let pub = false;
    let nat = false;
    const numeroProvincias = 24;
    let modulo = 11;
    let digitoVerificador;

    let d1 = 0;
    let d2 = 0;
    let d3 = 0;
    let d4 = 0;
    let d5 = 0;
    let d6 = 0;
    let d7 = 0;
    let d8 = 0;
    let d9 = 0;
    let d10 = 0;
    let p1 = 0;
    let p2 = 0;
    let p3 = 0;
    let p4 = 0;
    let p5 = 0;
    let p6 = 0;
    let p7 = 0;
    let p8 = 0;
    let p9 = 0;
    let state = false;

    /* Verifico que el campo no contenga letras */
    for (let i = 0; i < numeroProvincias + 1; i++) {
      // CompositeUtilities.openError(,"Error","El código de la provincia
      // (dos primeros dígitos) es inválido");

      if (Number(numero.substring(0, 2)) === i) {
        state = true;
      }

    }
    if (!state) {
      console.log('El código de la provincia (dos primeros dígitos) es inválido');
      // errorValidacionId = "El código de la provincia (dos primeros dígitos) es inválido";
      return false;
    }

    /* Aqui almacenamos los digitos de la cedula en variables. */
    d1 = Number(numero.substring(0, 1));
    d2 = Number(numero.substring(1, 2));
    d3 = Number(numero.substring(2, 3));
    d4 = Number(numero.substring(3, 4));
    d5 = Number(numero.substring(4, 5));
    d6 = Number(numero.substring(5, 6));
    d7 = Number(numero.substring(6, 7));
    d8 = Number(numero.substring(7, 8));
    d9 = Number(numero.substring(8, 9));
    d10 = Number(numero.substring(9, 10));

    /* El tercer digito es: */
    /* 9 para sociedades privadas y extranjeros */
    /* 6 para sociedades publicas */
    /* menor que 6 (0,1,2,3,4,5) para personas naturales */

    if (d3 === 7 || d3 === 8) {
      // CompositeUtilities.openError(this,"ERROR","El tercer dígito
      // ingresado es inválido");

      console.log('El tercer dígito ingresado es inválido');

      // errorValidacionId = 'El tercer dígito ingresado es inválido';
      return false;
    }

    /* Solo para personas naturales (modulo 10) */
    if (d3 < 6) {
      nat = true;
      p1 = d1 * 2;
      if (p1 >= 10) {
        p1 -= 9;
      }
      p2 = d2 * 1;
      if (p2 >= 10) {
        p2 -= 9;
      }
      p3 = d3 * 2;
      if (p3 >= 10) {
        p3 -= 9;
      }
      p4 = d4 * 1;
      if (p4 >= 10) {
        p4 -= 9;
      }
      p5 = d5 * 2;
      if (p5 >= 10) {
        p5 -= 9;
      }
      p6 = d6 * 1;
      if (p6 >= 10) {
        p6 -= 9;
      }
      p7 = d7 * 2;
      if (p7 >= 10) {
        p7 -= 9;
      }
      p8 = d8 * 1;
      if (p8 >= 10) {
        p8 -= 9;
      }
      p9 = d9 * 2;
      if (p9 >= 10) {
        p9 -= 9;
      }
      modulo = 10;
    }

    /* Solo para sociedades publicas (modulo 11) */
    /*
     * Aqui el digito verficador esta en la posicion 9, en las otras 2 en la
     * pos. 10
     */
    if (d3 === 6) {
      pub = true;
      p1 = d1 * 3;
      p2 = d2 * 2;
      p3 = d3 * 7;
      p4 = d4 * 6;
      p5 = d5 * 5;
      p6 = d6 * 4;
      p7 = d7 * 3;
      p8 = d8 * 2;
      p9 = 0;
    }

    /* Solo para entidades privadas (modulo 11) */
    if (d3 === 9) {
      pri = true;
      p1 = d1 * 4;
      p2 = d2 * 3;
      p3 = d3 * 2;
      p4 = d4 * 7;
      p5 = d5 * 6;
      p6 = d6 * 5;
      p7 = d7 * 4;
      p8 = d8 * 3;
      p9 = d9 * 2;
    }

    suma = p1 + p2 + p3 + p4 + p5 + p6 + p7 + p8 + p9;
    residuo = suma % modulo;

    /* Si residuo=0, dig.ver.=0, caso contrario 10 - residuo */
    digitoVerificador = residuo === 0 ? 0 : modulo - residuo;

    /* ahora comparamos el elemento de la posicion 10 con el dig. ver. */
    if (pub === true) {
      if (digitoVerificador !== d9) {
        // CompositeUtilities.openError(this,"ERROR","El ruc de la
        // empresa del sector público es incorrecto.");
        console.log('El ruc de la empresa del sector público es incorrecto.');
        // errorValidacionId = 'El ruc de la empresa del sector público es incorrecto.';
        return false;
      }
      /* El ruc de las empresas del sector publico terminan con 0001 */
      if (numero.substring(9, 14) !== '0001') {
        // CompositeUtilities.openError(this,"ERROR","El ruc de la
        // empresa del sector público debe terminar con 0001");
        console.log('El ruc de la empresa del sector público es incorrecto.');
        // errorValidacionId = 'El ruc de la empresa del sector público es incorrecto.';
        return false;
      }
    } else if (pri === true) {
      if (digitoVerificador !== d10) {
        // CompositeUtilities.openError(this,"ERROR","El ruc de la
        // empresa del sector privado es incorrecto.");
        console.log('El ruc de la empresa del sector privado es incorrecto.');
        // errorValidacionId = 'El ruc de la empresa del sector privado es incorrecto.';
        return false;
      }
      if (!numero.substring(10, 13).equalsIgnoreCase('001')) {

        console.log(' tamaño ' + numero.trim());
        // CompositeUtilities.openError(this,"ERROR","El ruc de la
        // empresa del sector privado debe terminar con 001");
        console.log('El ruc de la empresa del sector privado debe terminar con 001');
        // errorValidacionId = 'El ruc de la empresa del sector privado debe terminar con 001';
        return false;
      }
    } else if (nat === true) {
      if (digitoVerificador !== d10) {
        // CompositeUtilities.openError(this,"ERROR","El número de
        // cédula de la persona natural es incorrecto.");
        console.log('El número de cédula de la persona natural es incorrecto.');
        // errorValidacionId = 'El número de cédula de la persona natural es incorrecto.';
        return false;
      }
      if (numero.length > 10
        && !numero.substring(10, 13).equalsIgnoreCase('001')) {
        // CompositeUtilities.openError(this,"ERROR","El ruc de la
        // persona natural debe terminar con 001");

        console.log('El ruc de la persona natural debe terminar con 001');
        // errorValidacionId = 'El ruc de la persona natural debe terminar con 001';
        return false;
      }
    }
    return true;
  }
  //////


  ValidaRuc(ruc): number {
    let nroCedula;
    let tercerDigito;
    let decimoDigito;
    let decimoDigitoaux;
    let sum = 0;
    let contador = 0;
    let contadorPosicion = 0;
    let cociente;
    let decena;
    let verificador;
    let estadoRuc;
    let digitosRuc;

    if (ruc.length !== 13) {
      return estadoRuc = 0;
    }

    digitosRuc = ruc.substring(10, 13);
    if (digitosRuc === '001') {
      estadoRuc = 1;
    } else {
      return estadoRuc = 0;
    }

    if (ruc.length <= 0) {
      return estadoRuc = 0;
    }

    nroCedula = ruc.substring(0, 10); // cedula
    tercerDigito = ruc.substring(2, 3);
    decimoDigitoaux = ruc.substring(9, 10);

    if (nroCedula.length === 0 || ruc.length !== 13) {
      return estadoRuc = 0;
    }
    // El tercer dígito es siempre menor a 6: 0, 1, 2, 3, 4, 5 para Personas Naturales
    if (Number(tercerDigito) >= 0
      && Number(tercerDigito) <= 6
      && Number(decimoDigitoaux) !== 0) {
      const Idprovincia = ruc.substring(0, 2); // obtengo el tercer dígito

      if ((Number(Idprovincia) >= 1 && Number(Idprovincia) <= 24)
        || Number(Idprovincia) === 30) {
        decimoDigito = ruc.substring(9, 10);

        do {
          contadorPosicion = (2 * contador) + 1;
          const digCedula = nroCedula.charAt(contadorPosicion - 1);
          const digiCed = digCedula + '';
          let multi = Number(digiCed) * 2;
          if (multi >= 10) {
            multi = 1 + multi % 10;
          }
          sum = sum + multi;
          contador++;
        } while (contadorPosicion < 9);

        contador = 1;
        contadorPosicion = 1;
        do {
          contadorPosicion = 2 * contador;
          const digCedula = nroCedula.charAt(contadorPosicion - 1);
          const digiCed = digCedula + '';
          sum = sum + Number(digiCed);
          contador++;
        } while (contadorPosicion < 8);

        cociente = Math.trunc(sum / 10);
        decena = (cociente + 1) * 10;
        verificador = decena - sum;

        if (verificador === 10) {
          verificador = 0;
        }

        if (verificador === Number(decimoDigito)) {
          estadoRuc = 1;
        } else {
          estadoRuc = 0;
        }
      } else { // fin del if rango provincias
        return estadoRuc = 0;
      }
    } else { // fin if personas naturales
      // El tercer dígito 6 para Sociedades Públicas
      if (Number(tercerDigito) === 6
        && Number(tercerDigito) === 0) {
        const digUno = Number(nroCedula.substring(0, 1));
        const digDos = Number(nroCedula.substring(1, 2));
        const digTres = Number(nroCedula.substring(2, 3));
        const digCuatro = Number(nroCedula.substring(3, 4));
        const digCinco = Number(nroCedula.substring(4, 5));
        const digSeis = Number(nroCedula.substring(5, 6));
        const digSiete = Number(nroCedula.substring(6, 7));
        const digOcho = Number(nroCedula.substring(7, 8));
        const digNueve = Number(nroCedula.substring(8, 9));

        sum = digUno * 3 + digDos * 2 + digTres * 7 + digCuatro * 6
          + digCinco * 5 + digSeis * 4 + digSiete * 3 + digOcho * 2;

        do {
          sum = sum - 11;
        } while (sum > 11);
        let digVerif = 11 - sum;

        if (digVerif === 10) {
          digVerif = 0;
          return estadoRuc = 0;
        } else {
          if (digVerif !== digNueve) {
            return estadoRuc = 0;
          } else {
            return estadoRuc = 1;
          }
        }
      }// fin de if Sociedades Públicas

      // El tercer dígito 9 para Sociedades Privadas y Extranjeros sin cédula
      if (Number(tercerDigito) === 9) {
        const digUno = Number(nroCedula.substring(0, 1));
        const digDos = Number(nroCedula.substring(1, 2));
        const digTres = Number(nroCedula.substring(2, 3));
        const digCuatro = Number(nroCedula.substring(3, 4));
        const digCinco = Number(nroCedula.substring(4, 5));
        const digSeis = Number(nroCedula.substring(5, 6));
        const digSiete = Number(nroCedula.substring(6, 7));
        const digOcho = Number(nroCedula.substring(7, 8));
        const digNueve = Number(nroCedula.substring(8, 9));
        const digDiez = Number(nroCedula.substring(9, 10));

        sum = digUno * 4 + digDos * 3 + digTres * 2 + digCuatro * 7
          + digCinco * 6 + digSeis * 5 + digSiete * 4 + digOcho * 3
          + digNueve * 2;

        do {
          sum = sum - 11;
        } while (sum > 11);
        let digVerif = 11 - sum;

        if (digVerif === 10) {
          digVerif = 0;
          return estadoRuc = 0;
        } else {
          if (digVerif !== digDiez) {
            return estadoRuc = 0;
          } else {
            return estadoRuc = 1;
          }
        }
      }// fin de if Sociedades Privadas y Extranjeros sin cédula
    }
    return estadoRuc;
  }

  ValidaCedula(cedula): number {
    let sum1 = 0;
    let sum2 = 0;
    let digito;
    let mayorNueve;
    let estadoCedula = 0;

    if (cedula.length === 10) {

      let i;
      let mod;
      for (i = 1; i <= 9; i++) {
        const digitoCedcrc = cedula.charAt(i - 1);
        const digitoCed = digitoCedcrc + '';
        digito = Number(digitoCed);
        mod = i % 2;
        if (i % 2 === 0) {
          sum1 = sum1 + digito;
        } else {
          mayorNueve = digito * 2 > 9 ? (digito * 2) - 9 : digito * 2;
          sum2 = sum2 + mayorNueve; // + if(digito * 2 >9, (digito *
          // 2)-9, digito * 2);
        }
      }// fin for de 1 a 9
      digito = Number(((sum1 + sum2) + '').substring(1, 2));

      if (((10 - digito) + '') === (cedula.substring(9, 10))) {
        return estadoCedula = 1;
      }

      return estadoCedula = 0;
    } // fin if length() de cedula

    return 1;
  }
  async validaConsultaRespuesta(rucIde, ide) {

    let valRucIDe = 0;
    valRucIDe = 1
    if (ide === '1') {
      const resp = await this.utilitariosService.ValidaRucAutorizacion(rucIde);

      if (resp == 1) {
        valRucIDe = 1;
      } else {
        if (resp == 4) {
          valRucIDe = 4;
        } else if (resp == 3) {
          valRucIDe = 3;
        } else {
          valRucIDe = 0;
        }
      }
    }
    if (ide === '2') {
      if (rucIde !== '9999999999') {
        const resp = await this.utilitariosService.ValidaCedulaAutorizacion(rucIde, 1);
        if (resp == 1) {
          valRucIDe = 1;
        } else {
          if (resp == 4) {
            valRucIDe = 4;
          } else if (resp == 3) {
            valRucIDe = 3;
          } else {
            valRucIDe = 0;
          }
        }
      } else {
        valRucIDe = 0;
      }
    }


    return valRucIDe;

  }



  get totalCorrectos(): number {
    return this.venimpclientesService.impclientes.filter(cliente => cliente.ESTADO === 'VALIDO').length;
  }
  get totalErrores(): number {
    return this.venimpclientesService.impclientes.filter(cliente => cliente.ESTADO === 'ERROR').length;
  }
  get totalProcesados(): number {
    return this.venimpclientesService.impclientes.filter(cliente => cliente.ESTADO === 'PROCESADO').length;
  }


  /*VALIDAR GUARDAR ARREGLO  */
  async validarGuardar() {
    try {
      this.spin = true
      const clientes = this.venimpclientesService.impclientes || [];
      if (clientes.length === 0) {
        this.messageService.add({
          key: 'venimpcli',
          severity: 'error',
          summary: 'Informacion',
          detail: 'Debe iportar un archivo excel antes de guardar '
        })
        this.spin = false;
        return;
      }
      //console.log('pasa por aqui ')
      const clientesValidos = clientes.filter(item =>
        item.ESTADO !== 'ERROR' &&
        item.ESTADO !== 'PROCESADO' &&
        item.EXISTE !== 'SI'
      );
      // console.log(clientesValidos, 'clientes validos ')

      const clientesConError = clientes.filter(item =>
        item.ESTADO === 'ERROR' || (
          item.EXISTE === 'SI' &&
          item.ESTADO !== 'PROCESADO'
        )
      );

      const clientesProcesador = clientes.filter(item => item.ESTADO === 'PROCESADO');
      if (clientesProcesador.length === clientes.length) {
        this.messageService.add({
          key: 'venimpcli',
          severity: 'info',
          summary: 'Informacion',
          detail: 'Todos los clientes ya fueron procesados '
        });
        this.spin = false;
        return;
      };
      if (clientesValidos.length === 0) {
        this.messageService.add({
          key: 'venimpcli',
          severity: 'error',
          summary: 'Informacion',
          detail: 'No existe clientes validos para guardar, revise la columna observacion '
        });
        this.spin = false;
        return;
      }

      this.spin = false;
      this.confirmationService.confirm({
        message: 'Se guardaran ' + clientesValidos.length + ' clientes válidos y los clientes con errores seran omitidos . ¿Desea continuar?',
        header: 'Confirmar acción',
        icon: 'pi pi-exclamation-triangle',
        key: 'confirmvenimpcli',
        acceptLabel: 'SI',
        rejectLabel: 'NO',
        accept: async () => {
          await this.guardar(clientesValidos);
        }
      });
    } catch (error) {
      this.spin = false;
      this.messageService.add({
        key: 'venimpcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Hubo un Error al validar la informacion  '
      });
      console.log(error)
    }
  }
  async guardar(clientesValidos: Venimpcli[]): Promise<void> {
    try {
      this.spin = true;
      ///nuevoooo 

      if (!clientesValidos || clientesValidos.length === 0) {
        this.messageService.add({
          key: 'venimpcli',
          severity: 'infor',
          summary: 'Informacióm',
          detail: 'No existe clientes por guardar  '
        });
      }

      // const clientesPendientes =
      //   this.venimpclientesService
      //     .impclientes
      //     .filter(item =>
      //       item.EXISTE !== 'SI' &&
      //       item.ESTADO !== 'PROCESADO'
      //     )
      // if (clientesPendientes.length === 0) {
      //   this.messageService.add({
      //     key: 'venimpcli',
      //     severity: 'infor',
      //     summary: 'Informacióm',
      //     detail: 'No existe clientes por guardar  '
      //   });
      //   this.spin = false;
      //   return;
      // }
      const arregloClientes = clientesValidos.map(({
        COM_CODIGO, CLI_CODIGO, CLI_TIPOIDE, CLI_RUCIDE, CLI_NOMBRE, CLI_NOMBREC,
        VEN_CODIGO, GRU_CODIGO, CLI_DIRECCION1, CLI_TELEFONO1, CLI_CORREO,
        CON_CODIGO1, CON_CODIGO2, CLI_LISTA, CLI_FECHANACIMIENTO, CLI_SEXO, CLI_ESTCIV, CLI_PROVINCIA, CAN_CODIGO, PARR_CODIGO, CLI_VALIDACION }) => ({
          // p_ENCDEPCLI_NUMERO: iterator.NUMERO,
          p_COM_CODIGO: '01',
          p_CLI_CODIGO: CLI_CODIGO,
          p_CLI_TIPOIDE: CLI_TIPOIDE,
          p_CLI_RUCIDE: CLI_RUCIDE,
          p_CLI_NOMBRE: CLI_NOMBRE,
          p_CLI_NOMBREC: CLI_NOMBREC,
          p_VEN_CODIGO: VEN_CODIGO,
          p_GRU_CODIGO: GRU_CODIGO,
          p_CLI_DIRECCION1: CLI_DIRECCION1,
          p_CLI_TELEFONO1: CLI_TELEFONO1,
          p_CLI_CORREO: CLI_CORREO,
          p_CON_CODIGO1: CON_CODIGO1,
          p_CON_CODIGO2: CON_CODIGO2,
          p_CLI_LISTA: CLI_LISTA,
          P_CLI_FECHANACIMIENTO: CLI_FECHANACIMIENTO,
          P_CLI_SEXO: CLI_SEXO,
          P_CLI_ESTCIV: CLI_ESTCIV,
          p_CLI_PROVINCIA: CLI_PROVINCIA,
          p_CAN_CODIGO: CAN_CODIGO,
          p_PARR_CODIGO: PARR_CODIGO,
          p_CLI_VALIDACION: CLI_VALIDACION,
          p_USU_identificacion_4: this.venimpclientesService.usuario.identificacion,
          p_AUD_equipo: this.utilitariosService.getHostname(),
          p_AUD_ippublica: this.utilitariosService.getIpFrontend()

        }));
      console.log('Arreglo enviadro para guardar ', arregloClientes);
      const respuesta: any = await this.venimpclientesService.insertarRegistroDet(arregloClientes);
      console.log('Respuesta del backend ', respuesta)

      let guardados = 0
      let errores = 0

      clientesValidos.forEach(cliente => {
        cliente.EXISTE = 'SI',
          cliente.ESTADO = 'PROCESADO',
          cliente.OBSERVACION = 'Cliente guardado correctamente'
      });
      this.haycambiosSinGuardar = false;
      if (this.aggrid) {
        this.aggrid.refreshaggrid(this.venimpclientesService.impclientes, this.defaultImpcliente.objeto);
      }
      // for (const cliente of clientesValidos) {
      //   try {
      //     await this.venimpclientesService.procesarclientes(cliente);

      //     cliente.EXISTE = 'SI';
      //     cliente.ESTADO = 'PROCESADO';
      //     cliente.OBSERVACION = 'Cliente guardado correctamente';
      //     guardados++;
      //     this.haycambiosSinGuardar = false;

      //   } catch (error) {
      //     console.error('Error guardando cliente');
      //     await this.venimpclientesService.procesarclientes(cliente);
      //     cliente.EXISTE = 'NO';
      //     cliente.ESTADO = 'ERROR';
      //     cliente.OBSERVACION = 'NO SE PUDO GUARDAR ';
      //     errores++;
      //   }
      //   if (this.aggrid) {
      //     this.aggrid.refreshaggrid(this.venimpclientesService.impclientes, this.defaultImpcliente.objeto);
      //   }
      // }
      this.botonGuardar = errores === 0;
      this.botonBorrar = false;
      this.botonRegresar = false;
      if (errores === 0) {
        this.messageService.add({
          key: 'venimpcli',
          severity: 'success',
          summary: 'Informacióm',
          detail: arregloClientes.length + ' Clientes fueron guardados correctamente '
        });
      } else {
        this.messageService.add({
          key: 'venimpcli',
          severity: 'warn',
          summary: 'Procesado finalizado',
          detail: arregloClientes.length + ' Clientes guardados y ' + errores + 'clientes con errores '
        });
      }


    } catch (error) {
      console.error('errro compleot ', error);
      console.error('Status ', status);
      console.error('resp back  ', error?.error);
      console.error('mensaje ', error?.message);
      const mensajeBackend = error?.error?.mensaje ||
        error?.error?.mensaje ||
        error?.error?.error ||
        error?.mensaje ||
        'error desconocido al guardar '

      this.messageService.add({
        key: 'venimpcli',
        severity: 'error',
        summary: 'Error',
        detail: mensajeBackend
      });

    } finally {
      this.spin = false;
    }
  }
}
